export const getPointsColTitle = (isPublicationSubscription: boolean): string => {
  return isPublicationSubscription ? 'Придёт в баллах' : 'Баллы';
};
